<template>
<div id="main" class="column is-9">
			<section class="report-problem">
			<div class="columns">
				<div class="column">
					<h1>Report a Problem</h1>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="card">
						<div class="card-table">
							<div class="content">
								<div class="columns">
									<div class="column">
										<form>
											<label class="label">Categorize the Complaint:</label>
											<div class="columns">
												<div class="column">
													<div class="complaint-categories is-maxed">
													<div class="field is-maxed">
														<div class="control">
															<label class="radio">
															<input type="radio" value="Connection issue" v-model="problem.category">
															Connection issue </label>
														</div>
													</div>
													<div class="field is-maxed">
														<div class="control">
															<label class="radio">
															<input type="radio" value="Status stuck" v-model="problem.category">
															Status stuck </label>
														</div>
													</div>
													<div class="field is-maxed">
														<div class="control">
															<label class="radio">
															<input type="radio" value="Dropped call" v-model="problem.category">
															Dropped call </label>
														</div>
													</div>
													<div class="field is-maxed">
														<div class="control">
															<label class="radio">
															<input type="radio" value="Call/minutes didn't count" v-model="problem.category">
															Call/minutes didn't count </label>
														</div>
													</div>
													</div>
												</div>
												<div class="column">
													<div class="field is-maxed">
														<div class="control">
															<label class="radio">
															<input type="radio" value="Can't receive callbacks" v-model="problem.category">
															Can't receive callbacks </label>
														</div>
													</div>
													<div class="field is-maxed">
														<div class="control">
															<label class="radio">
															<input type="radio" value="Bad reception" v-model="problem.category">
															Bad reception </label>
														</div>
													</div>
													<div class="field is-maxed">
														<div class="control">
															<label class="radio">
															<input type="radio" value="Other" v-model="problem.category">
															Other </label>
														</div>
													</div>
												</div>
											</div>
											<label class="label">What Happened?:*</label>
											<p>
												Please include any details surrounding your complaint/issue.
											</p>
											<div class="field">
												<div class="control">
													<textarea ref="details" class="textarea" :class="{'is-danger': errors.details }" placeholder="" rows="10" v-model="problem.details"></textarea>
													<p class="help is-danger" v-if="errors.details">{{ errors.details }}</p>
												</div>
											</div>
											<div class="field is-maxed">
												<div class="control">
													<button class="button is-small is-link" v-if="idle" @click.prevent="reportProblem()">Submit</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
			</div></div></section>
		</div>
</template>

<script>
	function cleanErrors() {
		return {
			details: null
		}
	}
	export default {
        props: {
            done: String
        },
		data() {
			return {
				idle: true,
				errors: {
					details: null
				},
				problem: {
					category: "Other",
					details: ""
				}
			}
		},
		methods: {
			checkForm() {
				this.errors = cleanErrors()
				if (!this.problem.details || this.problem.details.trim().length == 0) {
					this.errors.details = "Details are required"
					console.log(this.errors)
				} 

				for (const key in this.errors) {
					if (this.errors[key] !== null) { return false }
				}

				return true
			},
			async reportProblem() {
				if (this.checkForm()) {
					this.idle = false
					await this.$root.$data.setters.reportProblem(this.$root.$data.state, JSON.parse(localStorage.getItem("user")).user_id, this.problem)
					this.$notify({
						group: 'global',
						type: 'success',
						title: 'Problem Submitted',
						text: 'Your problem was submitted successfully.',
					})
					this.$router.push(this.done)
				}
			}
		}
	}
</script>